"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookies = getCookies;
exports.getSwitchUserIdFromCookie = getSwitchUserIdFromCookie;
exports.setSwitchUserIdToCookie = setSwitchUserIdToCookie;
exports.clearSwitchUserIdCookie = clearSwitchUserIdCookie;
const universal_cookie_1 = __importDefault(require("universal-cookie"));
function getCookies(cookie) {
    return new universal_cookie_1.default(cookie);
}
/**
 * Name of the cookie that will be used to store the ID of impersonated user.
 */
const IMPERSONATED_USER_COOKIE = 'LithiumImpersonatedUser';
/**
 * The path of the cookie that will be used to store the ID of impersonated user.
 */
const IMPERSONATED_USER_COOKIE_PATH = '/';
/**
 * Gets the switched user.
 *
 * @param cookie the cookie string only needed for SSR
 */
function getSwitchUserIdFromCookie(cookie) {
    const id = getCookies(cookie).get(IMPERSONATED_USER_COOKIE);
    if (id) {
        const idAsNumber = Number.parseInt(id);
        if (!Number.isNaN(idAsNumber)) {
            return idAsNumber;
        }
    }
    return null;
}
/**
 * Function to store the impersonated user's ID on cookie
 *
 * @param userId the impersonated user's ID
 */
function setSwitchUserIdToCookie(userId) {
    const expires = new Date();
    // expire in 30 minutes
    expires.setTime(expires.getTime() + 30 * 60 * 1000);
    getCookies().set(IMPERSONATED_USER_COOKIE, userId, {
        path: IMPERSONATED_USER_COOKIE_PATH,
        expires
    });
}
/**
 * Function to remove the impersonated user's ID cookie
 */
function clearSwitchUserIdCookie() {
    getCookies().remove(IMPERSONATED_USER_COOKIE, { path: IMPERSONATED_USER_COOKIE_PATH });
}
//# sourceMappingURL=SwitchUserHelper.js.map